import React from 'react';
// import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';

import { I18n } from 'components';

import { getPricePeriod } from '../../../Home/selectors';
import { getFTTBSubscriptionFee } from '../../store/selectors';
import styles from '../../styles.pcss';

const cx = classNames.bind(styles);

const _TariffPrice = ({ subscriptionFee, pricePeriod }) => {
  if (!subscriptionFee) return null;

  if (pricePeriod) {
    return (
      <div className={cx('price')}>{`${subscriptionFee} ₽ ${pricePeriod}`}</div>
    );
  }

  return (
    <I18n className={cx('price')} path="common.pricePerMonth" vars={{ sum: subscriptionFee }} />
  );
};

const mapStateToProps = (state) => ({
  subscriptionFee: getFTTBSubscriptionFee(state),
  pricePeriod: getPricePeriod(state),
});

export const TariffPrice = connect(mapStateToProps)(_TariffPrice);
